import styled from "styled-components";
import theme from "../../theme";
import { linkButtonStyles } from "../../components/common/ui";

export const Container = styled.div`
  a.ghost,
  a.primary {
    ${linkButtonStyles};
  }

  a.primary {
    border-color: ${theme.color.brandDark};
    background: ${theme.color.brandDark};
    color: #fff;

    &:hover {
      background: ${theme.color.brand};
    }
  }
`;

export const CardWrapper = styled.div`
  width: 100%;
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
`;

export const Wrapper = styled.div`
  width: 100%;
  display: grid;
  gap: 24px;
  grid-template-columns: repeat(2, minmax(0, 1fr));

  @media screen and (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

export const TableWrapper = styled.div`
  > div:last-child {
    padding: 0 8px 8px;
  }
`;
